/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const setSelectedClient = (data) => {
  return {
    type: 'SET_SELECTED_CLIENT',
    payload: data,
  };
};

export const setInvoiceNumber = (data) => {
  return {
    type: 'SET_INVOICE_NUMBER',
    payload: data,
  };
};

export const setReqRecordMailingData = (data) => {
  return {
    type: actionTypes.SET_REQ_RECORD_MAILING_DATA,
    payload: data,
  };
};

export const dispatchManufacturersByPQR = (data) => {
  return {
    type: actionTypes.GET_MANUFACTURERS_BY_PQR,
    payload: data,
  };
};

export const getManufacturersByPQR = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_MANUFACTURERS_BY_UNCHKMFG, values)
    .then((response) => {
      if (response.data.length == 0) {
        dispatch(setErrorMessages(['No Records Found']));
        dispatch(dispatchManufacturersByPQR(response.data));
      } else {
        return dispatch(dispatchManufacturersByPQR(response.data));
      }
    })
    .catch((response) => {
      dispatch(dispatchManufacturersByPQR(response.date));
    });
};

export const dispatchRecordMailingDate = (data) => {
  return {
    type: actionTypes.RECORD_MAILING_DATE,
    payload: data,
  };
};

export const calculateRecordMailingDate = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.RECORD_MAILING_DATE, values)
    .then((response) => {
      return dispatch(dispatchRecordMailingDate(response.data));
    })
    .catch(() => {
      dispatch(dispatchRecordMailingDate({ error: 'API failed' }));
    });
};

export const setDefaultQtr = (data) => {
  return {
    type: actionTypes.SET_DEFAULT_QTR,
    defaultQtrRMD: data,
  };
};

export const getMaxQuarterForFreezeDt = () => (dispatch) => {
  return axios
    .get(`${serviceEndPoint.GET_MAXQUARTER_FOR_FREEZE_DT}`)
    .then((response) => {
      return dispatch(setDefaultQtr(response.data));
    })
    .catch((response) => {
      dispatch(setDefaultQtr(response.date));
    });
};

export const setErrorMessages = (data) => {
  return {
    type: actionTypes.SET_ERROR_MESSAGES_REC_M_D,
    payload: data,
  };
};

export const resetRecordMailingDateStore = () => {
  return {
    type: actionTypes.RESET_RECORD_MAILING_DATE_STORE_REC_M_D,
  };
};
